/* esm.sh - highlight.js@11.11.1/lib/languages/julia-repl */
function e(a){return{name:"Julia REPL",contains:[{className:"meta.prompt",begin:/^julia>/,relevance:10,starts:{end:/^(?![ ]{6})/,subLanguage:"julia"}}],aliases:["jldoctest"]}}export{e as default};
//# sourceMappingURL=julia-repl.mjs.map